import { render } from "./AddInscription.vue?vue&type=template&id=606a6384&scoped=true&ts=true"
import script from "./AddInscription.vue?vue&type=script&lang=ts"
export * from "./AddInscription.vue?vue&type=script&lang=ts"

import "./AddInscription.vue?vue&type=style&index=0&id=606a6384&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606a6384"]])

export default __exports__